// extracted by mini-css-extract-plugin
module.exports = {"container":"GradinetContainer_container__3EDYa","gradient":"GradinetContainer_gradient__S92MV"};